<template>
  <div class="modal-profil-top">
    <div class="modal-profil-top__middle" v-if="profile">
      <!-- <img src="https://images.tokopedia.net/img/cache/215-square/shops-1/2019/8/5/6541191/6541191_8ef9ff89-467b-41e9-8125-1f7b09b39c18.jpg" alt=""> -->
      <div class="profile-card-logo">
        <div class="profile-card-circle">
          <img :src="`${api}/file/${profile.logo}`" alt="" v-if="profile && profile.logo" />
          <div :class="checkTotalInitial($get(profile, 'nama_vendor')) < 2
            ? 'initial-profile'
            : `initial-profile${checkTotalInitial(
              $get(profile, 'nama_vendor')
            )}`
            " v-else>
            {{ generateInitial($get(profile, 'nama_vendor')) }}
          </div>
        </div>
      </div>
    </div>
    <div class="modal-profil-top__rightside" v-if="profile">
      <div class="rs-title text-bold  flex-space-between">
        <span class="mr10">{{ profile.nama_vendor }}</span>
        <div class="flex-center" style="font-size:0.9rem">
          <input type="checkbox" :value="profile.auto_reminder" v-model="auto_reminder" />
          <span class="ml10">Auto Reminder</span>
        </div>
      </div>
      <div class="rs-type">
        {{ $get(profile, 'badan_usaha.alias_profile', '-') }} -
        {{ afiliationClass(profile) }}
      </div>
      <div class="rs-type">{{ profile.kota && profile.kota.desc }}</div>
      <div class="rs-rating">
        <div class="rs-rating__rate">
          {{
            convertNumberDescimal(
              $get(profile, 'kinerja_po.0.csi_score_avg', 0)
            )
          }}
        </div>
        <div>
          <span :class="kinerjaPoRating($get(profile, 'kinerja_po.0.csi_score_avg', 0), 1)
            ? 'star-active'
            : 'star-deactive'
            ">&#9733;</span>
          <span :class="kinerjaPoRating($get(profile, 'kinerja_po.0.csi_score_avg', 0), 2)
            ? 'star-active'
            : 'star-deactive'
            ">&#9733;</span>
          <span :class="kinerjaPoRating($get(profile, 'kinerja_po.0.csi_score_avg', 0), 3)
            ? 'star-active'
            : 'star-deactive'
            ">&#9733;</span>
          <span :class="kinerjaPoRating($get(profile, 'kinerja_po.0.csi_score_avg', 0), 4)
            ? 'star-active'
            : 'star-deactive'
            ">&#9733;</span>
          <span :class="kinerjaPoRating($get(profile, 'kinerja_po.0.csi_score_avg', 0), 5)
            ? 'star-active'
            : 'star-deactive'
            ">&#9733;</span>
        </div>
        <div class="rs-rating__devider">|</div>
        <div class="rs-rating__classification">
          {{ csiCategory($get(profile, 'kinerja_po.0.csi_score_avg', 0)) }}
        </div>
        <div class="rs-rating__devider">|</div>
        <div class="rs-rating__desc">
          <span class="text-underline text-bold text-black">{{
            $get(profile, 'kinerja_po.0.total_po')
          }}</span>
          PO dari
          <span class="text-underline text-bold text-black">{{
            monthDuration($get(profile, 'kinerja_po_date.0.PO_DATE', '-'))
          }}</span>
          Bulan Terakhir Kinerja PO
        </div>
      </div>
      <div class="rs-rating">
        <div class="rs-rating__rate">
          {{
            convertNumberDescimal($get(profile, 'kinerja_kontrak.0.grade', 0))
          }}
        </div>
        <div>
          <span :class="kinerjaKontrakRating(
            $get(profile, 'kinerja_kontrak.0.grade', 0),
            1
          )
            ? 'star-active'
            : 'star-deactive'
            ">&#9733;</span>
          <span :class="kinerjaKontrakRating(
            $get(profile, 'kinerja_kontrak.0.grade', 0),
            2
          )
            ? 'star-active'
            : 'star-deactive'
            ">&#9733;</span>
          <span :class="kinerjaKontrakRating(
            $get(profile, 'kinerja_kontrak.0.grade', 0),
            3
          )
            ? 'star-active'
            : 'star-deactive'
            ">&#9733;</span>
          <span :class="kinerjaKontrakRating(
            $get(profile, 'kinerja_kontrak.0.grade', 0),
            4
          )
            ? 'star-active'
            : 'star-deactive'
            ">&#9733;</span>
          <span :class="kinerjaKontrakRating(
            $get(profile, 'kinerja_kontrak.0.grade', 0),
            5
          )
            ? 'star-active'
            : 'star-deactive'
            ">&#9733;</span>
        </div>
        <div class="rs-rating__devider">|</div>
        <div class="rs-rating__classification">
          {{ spmCategory($get(profile, 'kinerja_kontrak.0.grade', '-')) }}
        </div>
        <div class="rs-rating__devider">|</div>
        <div class="rs-rating__desc">
          <span class="text-underline text-bold text-black">{{
            daysDuration(
              $get(
                profile,
                'kinerja_kontrak_date.0.SPM_PERFORMANCE_PERIOD_TO',
                '-'
              )
            )
          }}</span>
          Hari dari Kinerja Kontrak Terakhir
        </div>
      </div>
      <div class="rs-server">
        <div class="SAP">
          <img class="sap-logo" src="../../../assets/img/SAP.png" alt="" />
        </div>
        <div class="ARIBA" v-if="profile.ariba_code">
          ARIBA - {{ profile.ariba_code }}
        </div>
        <div class="BCE" v-if="profile.bce_code">
          BCE - {{ profile.bce_code }}
        </div>
        <div class="GEMS" v-if="profile.gems_code">
          GEMS - {{ profile.gems_code }}
        </div>
        <div class="BKES" v-if="profile.bkes_code">
          BKES - {{ profile.bkes_code }}
        </div>
      </div>
      <div class="rs-legal">
        <div class="text-grey">
          Legal Document Status
          <span style="color: #fff;
                   padding: 0 3px;"
            :style="{ backgroundColor: checkLegalStatus(profile.matrix, profile.legal_doc_list, profile.badan_usaha) ? 'green' : 'red' }">
            {{ checkLegalStatus(profile.matrix,
              profile.legal_doc_list, profile.badan_usaha) ? 'Complete' : 'Not Complete' }}
          </span>
          <!-- <span
            :class="
              profile.legal_document_status == 1
                ? 'status-complete'
                : 'status-not-complete'
            "
            >{{
              profile.legal_document_status == 1 ? 'Complete' : 'Not Complete'
            }}</span> -->
        </div>
      </div>
      <div class="rs-score" v-if="k3lKplh">
        <div>
          <span class="text-bold" :style="{ color: isK3lExpired(profile.k3l[0]) ? 'red' : 'black' }">
            {{ $get(profile, 'k3l.0.nilai', 0) }} -
            {{ getK3lCategories($get(profile, 'k3l.0.nilai', 0)) }}</span>
          K3L Score
        </div>
        <div class="mr5 ml5">|</div>
        <div>
          <!-- <span class="text-bold text-black"
            >{{ $get(profile, 'kplh.0.nilai', 0) }} -
            {{ getKplhCategories($get(profile, 'kplh.0.nilai', '-')) }}</span
          > -->
          <span class="text-bold" :style="{ color: isKplhExpired(profile.kplh[0]) ? 'red' : 'black' }">
            {{
              $get(profile, 'kplh.0.keterangan', null) &&
              `${$get(profile, 'kplh.0.keterangan')}
            - `
            }}
            {{ $get(profile, 'kplh.0.nilai', 0) }} -
            {{ $get(profile, 'kplh.0.tingkat_resiko') }}</span>
          KPLH Score
        </div>
        <div class="mr5 ml5">|</div>
        <div>
          <span class="text-bold text-black">{{ $get(profile, 'event.0.total_event', 0) }} - Total Event</span>
          {{
            monthDuration($get(profile, 'event_date.0.EVENT_CREATE_DATE', 0))
          }}
          Bulan Terakhir
        </div>
      </div>

      <div class="rs-activity">
        <div class="rsa-left">Kegiatan Usaha Utama</div>
        <div class="rsa-right">
          <div class="rsa-right-wrapper" v-for="(kbliItem, index) in profile.kbli" :key="index">
            <div class="rsa-name">{{ $get(kbliItem, 'kbli_sub.desc') }}</div>
            <div v-if="profile.badan_usaha.bidang_usaha_id != '2'" class="mr5 border-green">
              NIB <i class="fas fa-check-circle"></i>
            </div>
            <div class="mr5" v-if="shouldShowIZIN(kbliItem) && profile.badan_usaha.bidang_usaha_id != '2'"
              :class="{ 'border-red': !flagIzin(kbliItem), 'border-green': flagIzin(kbliItem) }">
              IZIN <i class="fas"
                :class="{ 'fa-circle-xmark': !flagIzin(kbliItem), 'fa-check-circle': flagIzin(kbliItem) }"></i>
            </div>
            <div v-if="shouldShowIZIN(kbliItem) && profile.badan_usaha.bidang_usaha_id != '2'"
              class="custom-tooltip-container">
              <i class="fas fa-circle-info"></i>
              <div class="custom-tooltip">
                <span v-html="getTooltipText(kbliItem)"></span>
                <div class="arrow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rs-activity-status">
        <div class="rsas-column">
          <div class="rsasc-desc">Nama Perusahaan</div>
          <div class="rsasc-row-title">
            <div class="rsasc-row-title__box">Bisnis Unit</div>
          </div>
          <div class="rsasc-row-title">
            <div class="rsasc-row-title__box">Status</div>
          </div>
          <!-- <div class="rsasc-row-title"><div class="rsasc-row-title__box">SIO</div></div> -->
        </div>
        <div class="rsas-column" v-for="(list, index) in profile.company_code" :key="index">
          <div class="rsasc-desc">
            <div class="rsasc-desc-name">
              {{ $get(list, 'nama_perusahaan', '-') }}
            </div>
          </div>
          <div class="rsasc-row-unit">
            <div class="unit-text">{{ $get(list, 'bisnis_unit', '-') }}</div>
          </div>
          <div class="rsasc-row-title">
            <div :class="$get(list, 'status') ? 'active-box' : 'danger-box'">
              {{ $get(list, 'status') == 1 ? 'Active' : 'Block' }}
            </div>
          </div>
          <!-- <div class="rsasc-row-title"><div :class="$get(list, 'sio') == 1 ? 'active-box' : 'danger-box'">{{ $get(list, 'sio') == 1 ? 'Active' : 'Block' }}</div></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
import Sidebar from '@/components/V2/ModalSidebar'

export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      api: api,
      k3lCategories: null,
      kplhCategories: null,
      modelAutoReminder: 0,
    }
  },
  computed: {
    profile() {
      return this.$store.state.level1.profile
    },
    auto_reminder: {
      get: function () {
        return this.profile.auto_reminder
      },
      set: function (newValue) {
        this.modelAutoReminder = newValue

        this.updateReminder(this.profile.id, newValue)
      },
    },
    k3lKplh: async function () {
      await this.getCriteria()

      if (this.k3lCategories && this.kplhCategories) {
        return true
      }

      return false
    },
  },
  methods: {

    checkLegalStatus(matrix, legal_doc, badan_usaha) {
      if (badan_usaha && badan_usaha.bidang_usaha_id == 2) return true
      let is_complate = 0
      let type_1 = 0
      let type_2 = 0
      let type_3 = 0
      let type_1_no = 0
      let type_2_no = 0
      let type_3_no = 0
      let document_ids = []

      for (let i of matrix) {
        let type = i.MLegalDocument && i.MLegalDocument.type
        let checkDoc = legal_doc.filter(legal => legal.legal_document_id == i.legal_document_id && legal.lampiran != "" && legal.lampiran)

        if (i.is_mandatory == 1) {
          if (checkDoc.length > 0) {
            if (type == 1) type_1 += 1
            if (type == 2) type_2 += 1
            if (type == 3) type_3 += 1
          } else {
            is_complate -= 1
            document_ids.push(i.legal_document_id)
          }
        }

        if (i.is_mandatory == 11 || i.is_mandatory == 12 || i.is_mandatory == 13) {
          if (checkDoc.length > 0) {
            if (type == 1) type_1 += 1
            if (type == 2) type_2 += 1
            if (type == 3) type_3 += 1
          }
          if (type == 1) type_1_no += 1
          if (type == 2) type_2_no += 1
          if (type == 3) type_3_no += 1
        }
      }

      let is_save = 0
      if (is_complate >= 0) {
        if (type_1_no > 0) {
          if (type_1 <= 0) is_save -= 1
        }

        if (type_2_no > 0) {
          if (type_2 <= 0) is_save -= 1
        }

        if (type_3_no > 0) {
          if (type_3 <= 0) is_save -= 1
        }
      } else {
        is_save -= 1
      }

      if (is_save >= 0) {
        return true
      }

      return false
    },
    shouldShowIZIN(kbliItem) {
      const izinAttributes = [
        "TDP", "SIUP", "SS", "IUJP", "SBUJK", "IUJPTL", "INUBBM", "SIUPAL", "IUPPJPB",
        "SIUPBM", "SIUJS", "SIUJPT", "IUI", "SIPL", "IUASDD"
      ];

      return izinAttributes.some(attr => kbliItem.kbli_sub[attr] !== 0);
    },

    formatDate(dateString) {
      const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      const formattedDate = new Date(dateString).toLocaleDateString('id-ID', options);
      return formattedDate;
    },
    getTooltipText(kbliItem) {
      const tooltipTexts = [];

      const izinAttributes = [
        { name: "TDP", value: 13 },
        { name: "SIUP", value: 14 },
        { name: "SS", value: 15 },
        { name: "IUJP", value: 16 },
        { name: "SBUJK", value: 17 },
        { name: "IUJPTL", value: 18 },
        { name: "INUBBM", value: 19 },
        { name: "SIUPAL", value: 20 },
        { name: "IUPPJPB", value: 21 },
        { name: "SIPBM", value: 22 },
        { name: "SIUJS", value: 23 },
        { name: "SIUJPT", value: 24 },
        { name: "IUI", value: 25 },
        { name: "SIPL", value: 26 },
        { name: "IUASDD", value: 37 }
      ];

      const legalDoc = this.profile.legal_doc;

      for (const izinAttr of izinAttributes) {
        const izinToShow = izinAttr.value;

        if (kbliItem.kbli_sub[izinAttr.name] === 1 || kbliItem.kbli_sub[izinAttr.name] === 11) {
          const izinLegalDocs = legalDoc?.filter(doc => doc.legal_document_id === izinToShow);

          if (izinLegalDocs && izinLegalDocs.length > 0) {
            const izinLegalDoc = izinLegalDocs[0];

            if (izinLegalDoc.lampiran) {
              if (izinLegalDoc.tanggal_berakhir === null) {
                tooltipTexts.push(`${izinAttr.name} - Tanpa batas waktu`);
              } else if (this.isExpired(izinLegalDoc.tanggal_berakhir)) {
                tooltipTexts.push(`${izinAttr.name} - Expired`);
              } else {
                const formattedDate = this.formatDate(izinLegalDoc.tanggal_berakhir);
                tooltipTexts.push(`${izinAttr.name} - Berlaku s/d ${formattedDate}`);
              }
            } else {
              tooltipTexts.push(`${izinAttr.name} - Tidak ada dokumen`);
            }
          }
        }
      }

      return tooltipTexts.join('<br><br>');
    },

    flagIzin(kbliItem) {
      const izinAttributes = [
        { name: "TDP", value: 13 },
        { name: "SIUP", value: 14 },
        { name: "SS", value: 15 },
        { name: "IUJP", value: 16 },
        { name: "SBUJK", value: 17 },
        { name: "IUJPTL", value: 18 },
        { name: "INUBBM", value: 19 },
        { name: "SIUPAL", value: 20 },
        { name: "IUPPJPB", value: 21 },
        { name: "SIUPBM", value: 22 },
        { name: "SIUJS", value: 23 },
        { name: "SIUJPT", value: 24 },
        { name: "IUI", value: 25 },
        { name: "SIPL", value: 26 },
        { name: "IUASDD", value: 37 }
      ];

      const legalDoc = this.profile.legal_doc;

      if (!kbliItem || !legalDoc || !Array.isArray(legalDoc)) {
        return false;
      }

      let isGroupValid = false;

      for (const izinAttr of izinAttributes) {
        const izinToShow = izinAttr.value;
        const izinLegalDocs = legalDoc?.filter(doc => doc.legal_document_id === izinToShow);

        if (kbliItem.kbli_sub[izinAttr.name] === 11) {
          if (izinLegalDocs.length > 0) {
            if (izinLegalDocs.some(doc => doc.lampiran && !this.isExpired(doc.tanggal_berakhir))) {
              return true;
            } else if (izinLegalDocs.some(doc => doc.lampiran && doc.tanggal_berakhir === null)) {
              return true;
            }
          } else {
            return false;
          }
        } else if (kbliItem.kbli_sub[izinAttr.name] === 1) {
          const izinLegalDoc = izinLegalDocs?.[0];

          if (izinLegalDoc) {
            if (izinLegalDoc.lampiran && izinLegalDoc.tanggal_berakhir === null) {
              return true;
            } else if (izinLegalDoc.lampiran && !this.isExpired(izinLegalDoc.tanggal_berakhir)) {
              isGroupValid = true;
            }
          } else {
            return false;
          }
        }
      }

      if (isGroupValid) {
        return true;
      }

      return izinAttributes.every(attr => kbliItem.kbli_sub[attr.name] === 0);
    },

    isExpired(dateString) {
      const currentDate = new Date();
      const expiryDate = new Date(dateString);
      return expiryDate < currentDate;
    },

    findLegalDocById(kbliItem, legalDocId) {
      return kbliItem.legal_doc?.find(
        doc => doc.legal_document_id === legalDocId
      );
    },
    isKplhExpired(data) {
      if (!data || !data.tanggal_berakhir) return false;
      const today = new Date();
      const expirationDate = new Date(data.tanggal_berakhir);
      return expirationDate < today;
    },
    isK3lExpired(data) {
      if (!data || !data.tanggal_berakhir) return false;
      const today = new Date();
      const expirationDate = new Date(data.tanggal_berakhir);
      return expirationDate < today;
    },
    async updateReminder(id, value) {
      try {
        const url = `${api}/api/v1/d-vendor-profile/${id}`
        const { data: response } = await axios({
          method: 'PUT',
          url: url,
          data: {
            auto_reminder: value,
          },
        })

        if (response && response.status == 'success') {
          this.$store.commit('SET_NOTIF', response.message)
        }
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async getCriteria() {
      try {
        const urlK3l = `${api}/api/v1/k3l-categories?page=1&limit=50`
        const urlKplh = `${api}/api/v1/kplh-categories?page=1&limit=50`

        const { data: k3l } = await axios({
          method: 'GET',
          url: urlK3l,
        })

        const { data: kplh } = await axios({
          method: 'GET',
          url: urlKplh,
        })

        this.k3lCategories = k3l.data
        this.kplhCategories = kplh.data
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    getK3lCategories(value) {
      const categories = this.k3lCategories
      if (value && value > 0) {
        if (categories) {
          for (let i in categories) {
            if (
              categories[i].score_min <= value &&
              categories[i].score_max >= value
            )
              return categories[i].desc
          }
        }
      }

      return '-'
    },
    getKplhCategories(value) {
      const categories = this.kplhCategories
      if (value && value > 0) {
        if (categories) {
          for (let i in categories) {
            if (
              categories[i].score_min <= value &&
              categories[i].score_max >= value
            )
              return categories[i].desc
          }
        }
      }

      return '-'
    },
  },
}
</script>

<style scoped>
.custom-tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
  color: cornflowerblue;
}

.custom-tooltip {
  position: absolute;
  min-width: 65px;
  width: auto;
  top: 50%;
  left: 100%;
  margin-left: 10px;
  transform: translateY(-50%);
  background-color: #a1a1a1;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  opacity: 0;
  display: none;
  transition: opacity 0.3s;
  pointer-events: none;
}

.custom-tooltip .arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 7px 5px 0;
  border-color: transparent #a1a1a1 transparent transparent;
  left: -6px;
  top: 50%;
  transform: translateY(-50%);
}

.custom-tooltip span {
  display: block;
}

.custom-tooltip-container:hover .custom-tooltip {
  opacity: 1;
  display: block;
}
</style>
